<template>
  <component
    :is="component"
    :class="$style.root">
    <Label :class="$style.label">
      <input
        type="radio"
        :value="value"
        :class="$style.input"
        :name="name"
        :checked="selectedValue === value"
        @change="handleInputChange">
        <span v-if="label" class="ml-2">{{label}}</span>
    </Label>
  </component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'Radio',

  mixins: [ defaultRootComponent('span') ],

  props: {

    label: {
      type: String
    },

    value: {
      type: String,
    },

    name: {
      type: String,
    },

    selectedValue: {
      type: String,
    },
  },

  model: {
    prop: 'selectedValue',
    event: 'change'
  },

  methods: {
    handleInputChange(e) {
      this.$emit('change', e.target.value)
    }
  }

}

</script>

<style module>

  .root {
     @apply
      relative
  }

  .label {
    @apply
      inline-flex
      items-center
  }

  .input {
    @apply
      inline-block
      rounded-full
      border
      border-dull
      bg-dull-light
      text-primary
      w-4
      h-4
      select-none
      align-middle
      outline-none
      appearance-none
  }

  .input:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }

</style>
